module.exports = __webpack_public_path__ + "static/media/w_b_25.2f727d79.png";